// Mirrors the server rule (api LocationEmailIdentity.validateLocalPart,
// TRK-6050 decision 7): 1-64 chars a-z0-9._-, starts with a letter or digit,
// no two dots in a row, no trailing dot. Lowercased first. Returns an error
// message or undefined when valid.
export function validateLocalPart(raw: string): string | undefined {
  const localPart = raw.trim().toLowerCase()
  if (localPart.length < 1 || localPart.length > 64) {
    return `Local part must be 1 to 64 characters`
  }
  if (!/^[a-z0-9][a-z0-9._-]*$/.test(localPart)) {
    return `Use only letters, digits, dot, dash, underscore and start with a letter or digit`
  }
  if (localPart.includes(`..`)) return `Local part may not contain two dots in a row`
  if (localPart.endsWith(`.`)) return `Local part may not end with a dot`
  return undefined
}
